'use client';
import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next-nprogress-bar';
import { useState } from 'react';

export const useLogout = () => {
  const queryClient = useQueryClient();
  const router = useRouter();
  const [pending, setPending] = useState(false);

  const logout = async () => {
    try {
      setPending(true);
      queryClient.clear();
      await fetch('/api/logout', { method: 'POST' });
      const callbackUrl = `${window.location.pathname}${window.location.search}`;
      router.push(`/auth/login${callbackUrl !== '/' ? `?callbackUrl=${encodeURIComponent(callbackUrl)}` : ''}`);
    } catch (e) {
      console.error('Logout failed', e);
    } finally {
      setPending(false);
    }
  };

  return {
    logout,
    pending,
  };
};
